import { render, staticRenderFns } from "./integralDistribution.vue?vue&type=template&id=4b87f6c5&scoped=true&"
import script from "./integralDistribution.vue?vue&type=script&lang=js&"
export * from "./integralDistribution.vue?vue&type=script&lang=js&"
import style0 from "./integralDistribution.vue?vue&type=style&index=0&id=4b87f6c5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87f6c5",
  null
  
)

export default component.exports